import React from 'react';
import { KanbanCardField } from '../../Views/KanbanBoard/Board';

interface TextKanbanFieldProps {
    field:KanbanCardField
}

export const LongTextKanbanField = ({field}: TextKanbanFieldProps) => {
    const {
        displayValue
    } = field;

    return (
        <div>{displayValue ?? ''}</div>
    )
}

export default LongTextKanbanField;